/* eslint-disable no-unused-vars */
import React, { useEffect } from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import AddIcon from '@material-ui/icons/Add';
import { useDispatch, useSelector } from 'react-redux';
import SideBarListStyles from '../../styles/SideBarListStyle';
import FloatButton from '../sidebar/FloatButton';
import { getRulesDetails, setRulesDetails, showProgress } from '../../redux/actions/DealershipActions';
import ShowProgress from '../ui/Backdrop';
import service from '../../apis/service';
import { ErrorToast } from '../utils/Utils';
import RuleAddNewPopup from './RulesAddNewPopup';
import { apiEndpoints } from '../../constants/apiEndpoints';

export default function SidebarListRules(props) {
  const { filterArray } = props;
  const classes = SideBarListStyles();
  const [isAddNewPopupOpen, setIsAddNewPopupOpen] = React.useState(false);
  const selectedId = useSelector((state) => state.rulesData.selectedId);
  const dispatch = useDispatch();

  const myRefs = filterArray?.reduce((acc, val) => {
    acc[val.id] = React.createRef();
    return acc;
  }, {});

  useEffect(() => {
    myRefs[selectedId]?.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  }, [selectedId, filterArray]);

  const handleListItemClick = (id) => {
    if (id !== selectedId) dispatch(getRulesDetails(id));
  };
  const addNewRule = () => {
    setIsAddNewPopupOpen(true);
  };

  const closeAddNewRule = () => {
    setIsAddNewPopupOpen(false);
  };

  useEffect(() => {
    async function readRulesId(id) {
      dispatch(showProgress(true));
      await service
        .get(apiEndpoints.RULES_BY_ID.replace('ID', id))
        .then((response) => {
          dispatch(setRulesDetails(response));
          dispatch(showProgress(false));
        })
        .catch((error) => {
          dispatch(showProgress(false));
          ErrorToast(error);
        });
    }
    if (selectedId) readRulesId(selectedId);
  }, [selectedId]);

  const fabs = [
    {
      color: 'primary',
      className: classes.fab,
      icon: <AddIcon />,
      label: 'Add',
    },
  ];

  return (
    <div className={classes.root}>
      <List component="nav" aria-label="secondary mailbox folder">
        {filterArray.map((data) => (
          <div key={data.id} className={selectedId === data.id ? classes.highlightItem : ''}>
            <ListItem
              key={data.id}
              button
              selected={selectedId === data.id}
              className={classes.listStyling}
              onClick={() => handleListItemClick(data.id)}
              ref={myRefs[data.id]}
            >
              <ListItemText
                primary={
                  <div>
                    <p
                      className={`
                          ${selectedId === data.id ? classes.listTextSelected : classes.listTextNonSelected}
                        `}
                    >
                      {data.name}
                    </p>
                  </div>
                }
                secondary={
                  <div>
                    <div
                      className={selectedId === data.id ? classes.listSubTextSelected : classes.listSubTextNonSelected}
                    >
                      <div className={classes.listSubTextJustify}>
                        <div>{`${data.journeyCount || 0} journeys`}</div>
                      </div>
                    </div>
                  </div>
                }
              />
            </ListItem>
          </div>
        ))}
      </List>
      <FloatButton fabs={fabs} value={0} mainTabID={11} onAddNewRule={addNewRule} />
      {isAddNewPopupOpen && (
        <RuleAddNewPopup
          handleListItemClick={handleListItemClick}
          close={closeAddNewRule}
          add
          refreshData={props.fetchData}
        />
      )}
      {<ShowProgress />}
    </div>
  );
}
